// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"8ff6a395","453":"9f00f00a"}[chunkId] + ".chunk.js";
};